import React from 'react';

/**
 * 상품 슬라이더 컴포넌트 속성 정의
 * 에디터의 속성 패널에서 사용할 속성 그룹 및 컨트롤 정의
 */
const ProductSliderProperties = [
  {
    group: '기본 설정',
    properties: [
      {
        name: 'componentProps.sliderTitle',
        label: '슬라이더 제목',
        control: 'TextField',
        defaultValue: '인기 상품'
      },
      {
        name: 'componentProps.showTitle',
        label: '제목 표시',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'componentProps.titleFontSize',
        label: '제목 폰트 크기',
        control: 'TextField',
        defaultValue: '18px'
      },
      {
        name: 'componentProps.titleFontWeight',
        label: '제목 폰트 두께',
        control: 'Select',
        options: [
          { value: '300', label: '얇게' },
          { value: '400', label: '일반' },
          { value: '500', label: '중간' },
          { value: '600', label: '두껍게' },
          { value: '700', label: '굵게' },
          { value: '800', label: '매우 굵게' }
        ],
        defaultValue: '600'
      },
      {
        name: 'componentProps.titleColor',
        label: '제목 색상',
        control: 'ColorPicker',
        defaultValue: '#333'
      }
    ]
  },
  {
    group: '슬라이드 설정',
    properties: [
      {
        name: 'componentProps.itemsPerSlide',
        label: '슬라이드 당 항목 수',
        control: 'Select',
        options: [
          { value: '1', label: '1개' },
          { value: '2', label: '2개' },
          { value: '3', label: '3개' },
          { value: '4', label: '4개' },
          { value: '5', label: '5개' },
          { value: '6', label: '6개' }
        ],
        defaultValue: '4'
      },
      {
        name: 'componentProps.autoSlide',
        label: '자동 슬라이드',
        control: 'Switch',
        defaultValue: true
      },
      {
        name: 'componentProps.autoSlideInterval',
        label: '자동 슬라이드 간격 (ms)',
        control: 'TextField',
        defaultValue: '3000'
      },
      {
        name: 'componentProps.showStock',
        label: '재고 표시',
        control: 'Switch',
        defaultValue: false
      }
    ]
  },
  {
    group: '필터링 설정',
    properties: [
      {
        name: 'componentProps.include_product_ids',
        label: '포함할 상품 ID',
        control: 'TextField',
        helpText: '쉼표로 구분하여 입력 (예: 73,74,75)',
        defaultValue: ''
      },
      {
        name: 'componentProps.exclude_product_ids',
        label: '제외할 상품 ID',
        control: 'TextField',
        helpText: '쉼표로 구분하여 입력 (예: 76,77)',
        defaultValue: ''
      },
      {
        name: 'componentProps.include_category_ids',
        label: '포함할 카테고리 ID',
        control: 'TextField',
        helpText: '쉼표로 구분하여 입력 (예: 14,15)',
        defaultValue: ''
      },
      {
        name: 'componentProps.exclude_category_ids',
        label: '제외할 카테고리 ID',
        control: 'TextField',
        helpText: '쉼표로 구분하여 입력 (예: 16,17)',
        defaultValue: ''
      }
    ]
  },
  {
    group: '스타일',
    properties: [
      {
        name: 'style.backgroundColor',
        label: '배경색',
        control: 'ColorPicker',
        defaultValue: 'transparent'
      },
      {
        name: 'style.borderRadius',
        label: '테두리 둥글기',
        control: 'TextField',
        defaultValue: '0px'
      },
      {
        name: 'style.borderColor',
        label: '테두리 색상',
        control: 'ColorPicker',
        defaultValue: '#eeeeee'
      },
      {
        name: 'style.borderWidth',
        label: '테두리 두께',
        control: 'TextField',
        defaultValue: '1px'
      },
      {
        name: 'style.boxShadow',
        label: '그림자',
        control: 'TextField',
        defaultValue: 'none'
      },
      {
        name: 'style.padding',
        label: '패딩',
        control: 'TextField',
        defaultValue: '0 15px'
      },
      {
        name: 'style.margin',
        label: '마진',
        control: 'TextField',
        defaultValue: '0'
      }
    ]
  }
];

export default ProductSliderProperties; 